import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
export class HomeLeiteValidators {
  private constructor() {}

  static greaterThanEqual(limit: number): ValidatorFn {
    const validatorFn: (
      control: AbstractControl
    ) => { [key: string]: any } | null = (control) => {
      const value = Number(control.value);
      if (isNaN(value) || value < limit) {
        return { invalidValue: { value } };
      }

      return null;
    };

    return (control) => validatorFn(control);
  }

  static greaterThan(limit: number): ValidatorFn {
    const validatorFn: (
      control: AbstractControl
    ) => { [key: string]: any } | null = (control) => {
      const value = Number(control.value);
      if (isNaN(value) || value <= limit) {
        return { invalidValue: { value } };
      }

      return null;
    };
    return (control) => validatorFn(control);
  }

  static requiredIf(predicate: () => boolean = () => true): ValidatorFn {
    return predicate() ? Validators.required : null;
  }

  static matches(
    formControlName: string,
    confirmFormControlName: string
  ): ValidatorFn {
    const validatorFn: (
      control: AbstractControl,
      confirmControl: AbstractControl
    ) => { [key: string]: any } | null = (control, confirmControl) => {
      if (!control && !confirmControl) {
        return null;
      }
      const result =
        control.value === confirmControl.value ? null : { unmatching: true };
      return result;
    };

    return (control: AbstractControl) =>
      validatorFn(
        control.get(formControlName),
        control.get(confirmFormControlName)
      );
  }
}

export class HomeleiteValidatorsUtils {
  static isValid(obj: any): boolean {
    return obj ? obj.isValid() : false;
  }

  static isValidOptional(obj: any): boolean {
    return obj ? obj.isValid() : true;
  }
}
